export const SEPARATION_API_PATH = '/finances/api/v1/transactions/separation'

/**
 * Mirrors the API's own enum. 'mix' is deliberately absent: it is the expand sentinel the
 * screen uses, not something the endpoint accepts.
 */
export enum SeparationAnswerValue {
  Business = 'business',
  Personal = 'personal',
  Unsure = 'unsure',
  OwnerDraw = 'owner_draw',
  BusinessTransfer = 'business_transfer',
  OwnerContribution = 'owner_contribution',
  BusinessIncome = 'business_income',
  CardPayment = 'card_payment',
}

export const SEPARATION_ANSWER_VALUES: string[] = Object.values(
  SeparationAnswerValue
)

export const FETCH_SEPARATION_QUESTIONS_KEY = 'FETCH_SEPARATION_QUESTIONS_KEY'
export const SUBMIT_SEPARATION_ANSWERS_KEY = 'SUBMIT_SEPARATION_ANSWERS_KEY'
export const COMPLETE_SEPARATION_KEY = 'COMPLETE_SEPARATION_KEY'
export const SKIP_SEPARATION_KEY = 'SKIP_SEPARATION_KEY'

/** Mirrors the API's own enum: the sorting screens a user can skip from. */
export enum SeparationSkipScreen {
  TransactionReview = 'transaction_review',
  Question = 'question',
  InProgress = 'in_progress',
  LoadError = 'load_error',
}

/** Separation usually finishes in seconds, but a large import takes minutes. */
export const POLL_START_MS = 2000
export const POLL_MAX_MS = 15000

export const MIX_VALUE = 'mix'

export const SINGLE_TOGGLE_OPTIONS = [
  { value: 'business', label: 'Business', caption: 'Tax deductible expense' },
  { value: 'personal', label: 'Personal', caption: 'Kept out of books' },
]

export const TOGGLE_OPTIONS = [
  ...SINGLE_TOGGLE_OPTIONS.map((option) => ({
    ...option,
    label: `All ${option.label}`,
  })),
  { value: MIX_VALUE, label: "It's a Mix", caption: 'Mark individually' },
]

export const ROW_OPTIONS = [
  { value: 'business', label: 'Business' },
  { value: 'personal', label: 'Personal' },
  { value: 'unsure', label: 'Unsure' },
]
